import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { HeaderTitle, Icon } from '@atlas/ui';

const SignUpHeader = ({ onClose, signUpPopup, title = 'registration' }) => {
  return (
    <HeaderTitle className="center block-lg border" title={title}>
      {signUpPopup && (
        <div className="header-title__children">
          <div
            onClick={onClose}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClose();
              }
            }}
            role="button"
            tabIndex={0}
          >
            <Icon name="close" />
          </div>
        </div>
      )}
    </HeaderTitle>
  );
};

SignUpHeader.propTypes = {
  onClose: PropTypes.func,
  signUpPopup: PropTypes.bool,
  title: PropTypes.string,
};

export default memo(SignUpHeader);
